import {Action} from '@ngrx/store';

export enum ClientsActionTypes {
  GET_CLIENT = '[SHARED TOAST] Get Clients',
  GET_CLIENT_SUCCESS = '[SHARED TOAST] Get Clients Success',
  GET_CLIENT_ERROR = '[SHARED TOAST] Get Clients Error',

  GET_CLIENT_BY_PHONE = '[SHARED TOAST] Get Clients By Phone',
  GET_CLIENT_BY_PHONE_SUCCESS = '[SHARED TOAST] Get Clients By Phone Success',
  GET_CLIENT_BY_PHONE_ERROR = '[SHARED TOAST] Get Clients By Phone Error',

  GET_ALL_CLIENTS = '[SHARED TOAST] Get All Clients',
  GET_ALL_CLIENTS_SUCCESS = '[SHARED TOAST] Get All Clients Success',
  GET_ALL_CLIENTS_ERROR = '[SHARED TOAST] Get All Clients Error',

  GET_MANAGER_BY_FILIAL = '[SHARED TOAST] Get Managers by filial',
  GET_MANAGER_BY_FILIAL_SUCCESS = '[SHARED TOAST] Get Managers by filial Success',
  GET_MANAGER_BY_FILIAL_ERROR = '[SHARED TOAST] Get Managers by filial Error',

  GET_SORTED_MANAGER_BY_FILIAL = '[SHARED TOAST] Get Sorted Managers by filial',
  GET_SORTED_MANAGER_BY_FILIAL_SUCCESS = '[SHARED TOAST] Get Sorted Managers by filial Success',
  GET_SORTED_MANAGER_BY_FILIAL_ERROR = '[SHARED TOAST] Get Sorted Managers by filial Error',

  GET_MANAGER_BY_HEAD_MANAGER = '[SHARED TOAST] Get Managers by Head Manager',
  GET_MANAGER_BY_HEAD_MANAGER_SUCCESS = '[SHARED TOAST] Get Managers by Head Manager Success',
  GET_MANAGER_BY_HEAD_MANAGER_ERROR = '[SHARED TOAST] Get Managers by Head Manager Error',
}

export class GetClients implements Action {
  readonly type = ClientsActionTypes.GET_CLIENT;

  constructor(public payload: any) {
  }
}

export class GetClientsSuccess implements Action {
  readonly type = ClientsActionTypes.GET_CLIENT_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetClientsError implements Action {
  readonly type = ClientsActionTypes.GET_CLIENT_ERROR;

  constructor(public payload: any) {
  }
}

export class GetClientsByPhone implements Action {
  readonly type = ClientsActionTypes.GET_CLIENT_BY_PHONE;

  constructor(public payload: any) {
  }
}

export class GetClientsByPhoneSuccess implements Action {
  readonly type = ClientsActionTypes.GET_CLIENT_BY_PHONE_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetClientsByPhoneError implements Action {
  readonly type = ClientsActionTypes.GET_CLIENT_BY_PHONE_ERROR;

  constructor(public payload: any) {
  }
}

export class GetAllClients implements Action {
  readonly type = ClientsActionTypes.GET_ALL_CLIENTS;
}

export class GetAllClientsSuccess implements Action {
  readonly type = ClientsActionTypes.GET_ALL_CLIENTS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllClientsError implements Action {
  readonly type = ClientsActionTypes.GET_ALL_CLIENTS_ERROR;

  constructor(public payload: any) {
  }
}

export class GetManagersByFilial implements Action {
  readonly type = ClientsActionTypes.GET_MANAGER_BY_FILIAL;

  constructor(public payload: any) {
  }
}

export class GetManagersByFilialSuccess implements Action {
  readonly type = ClientsActionTypes.GET_MANAGER_BY_FILIAL_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetManagersByFilialError implements Action {
  readonly type = ClientsActionTypes.GET_MANAGER_BY_FILIAL_ERROR;

  constructor(public payload: any) {
  }
}

export class GetSortedManagersByFilial implements Action {
  readonly type = ClientsActionTypes.GET_SORTED_MANAGER_BY_FILIAL;

  constructor(public payload: any) {
  }
}

export class GetSortedManagersByFilialSuccess implements Action {
  readonly type = ClientsActionTypes.GET_SORTED_MANAGER_BY_FILIAL_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetSortedManagersByFilialError implements Action {
  readonly type = ClientsActionTypes.GET_SORTED_MANAGER_BY_FILIAL_ERROR;

  constructor(public payload: any) {
  }
}

export class GetManagersByHeadManager implements Action {
  readonly type = ClientsActionTypes.GET_MANAGER_BY_HEAD_MANAGER;
}

export class GetManagersByHeadManagerSuccess implements Action {
  readonly type = ClientsActionTypes.GET_MANAGER_BY_HEAD_MANAGER_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetManagersByHeadManagerError implements Action {
  readonly type = ClientsActionTypes.GET_MANAGER_BY_HEAD_MANAGER_ERROR;

  constructor(public payload: any) {
  }
}

export type ClientsActions =
  | GetClients
  | GetClientsSuccess
  | GetClientsError
  | GetClientsByPhone
  | GetClientsByPhoneSuccess
  | GetClientsByPhoneError
  | GetAllClients
  | GetAllClientsSuccess
  | GetAllClientsError
  | GetManagersByFilial
  | GetManagersByFilialSuccess
  | GetManagersByFilialError
  | GetManagersByHeadManager
  | GetManagersByHeadManagerSuccess
  | GetManagersByHeadManagerError
  | GetSortedManagersByFilial
  | GetSortedManagersByFilialSuccess
  | GetSortedManagersByFilialError;
